import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { NavLink, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import LeftArrow from './components/LeftArrow';
import RightArrow from './components/RightArrow';
import useIsMobile from '../../hook/useIsMobile';

export default function NewsDetailPage() {
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [newsList, setNewsList] = useState([]);
  const [news, setNews] = useState(null);

  const navigate = useNavigate();
  const isMobile = useIsMobile();

  useEffect(() => {
    if (newsList.length > 0) {
      initNews();
    }
  }, [id, newsList]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_STATIC_URL}/data/News_List.json`, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => res.json().then(data => setNewsList(data)));
  }, []);

  const initNews = () => {
    for (let i = newsList.length - 1; i >= 0; i--) {
      if (+newsList[i].id === +id) {
        setNews({ ...newsList[i], index: i, });
        return;
      }
    }

    navigate(`/news?${searchParams.toString()}`);
  }

  const clickMove = (id) => {
    navigate(`/news/detail/${id}?${searchParams.toString()}`);
  }

  return (
    <div>
      <Header />
      <main
        data-bg-type='white'
        className='wrapper my-[120px] lg:my-[240px]'
      >

        <NavLink
          to={`/news?${searchParams.toString()}`}
          className='flex items-center gap-[8px] font-bold text-heading3 lg:text-title3 text-label-300 cursor-pointer'>
          <LeftArrow /> 목록으로
        </NavLink>

        <div className='mt-[50px] lg:mt-[100px]'>
          <div>
            <div className='text-heading3 lg:text-heading1 text-label-0'>{news?.createDate}</div>
            <div className='mt-[16px] text-heading1 lg:text-title1 text-label-400'>{news?.title}</div>
          </div>

          <div className='mt-[50px] lg:mt-[100px]'>
            {
              news && <img
                src={`${process.env.REACT_APP_STATIC_URL}/images/News/${news?.image}`}
                className="w-full lg:w-[80%] mx-auto rounded-[16px]"
                alt={news?.title}
              />
            }
            <div
              className="news-content"
              dangerouslySetInnerHTML={{ __html: news?.content }}
            />
          </div>
        </div>

        <hr className='mt-[60px] lg:mt-[140px] mb-[40px] border-label-500 ' />

        <div className='relative flex flex-col'>
          {
            news?.index !== 0 &&

            <div
              className='lg:absolute lg:left-0 flex flex-col lg:w-1/2 gap-y-[12px] cursor-pointer'
              onClick={() => clickMove(+newsList[news?.index - 1]?.id)}
            >
              <div className='flex gap-x-[4px] items-center font-bold text-body1 text-label-300'>
                <LeftArrow /> 이전
              </div>
              <div className='font-semibold text-heading3 text-label-200'>{newsList[news?.index - 1]?.title}</div>
            </div>
          }

          {
            (news?.index !== 0 && news?.index + 1 !== newsList.length && isMobile) && <hr className='my-[24px]' />
          }

          {
            news?.index + 1 !== newsList.length &&

            <div
              className='lg:absolute lg:right-0 flex flex-col lg:w-1/2 lg:items-end lg:text-right gap-y-[12px] cursor-pointer'
              onClick={() => clickMove(+newsList[news?.index + 1]?.id)}
            >
              <div className='flex lg:flex-row-reverse gap-x-[4px] items-center font-bold text-body1 text-label-300'>
                <RightArrow /> 다음
              </div>
              <div className='font-semibold text-heading3 text-label-200'>
                {newsList[news?.index + 1]?.title}
              </div>
            </div>
          }
        </div>
      </main>
      <Footer />
    </div>
  )
}